<template>
  <div class="rbu-item-fluctuations">
    <ASorItemFluctuation
      v-for="(fluctuation, fluctuationIdx) in fluctuations"
      :key="fluctuationIdx"
      :fluctuation="fluctuation"
      :idx="fluctuationIdx"
      @update="onFluctuationUpdate(fluctuationIdx, $event)"
      @delete="onFluctuationDelete(fluctuationIdx)"
    ></ASorItemFluctuation>
  </div>
</template>

<script>
import ASorItemFluctuation from "@/components/asor/ASorItemFluctuation.vue";
import { computed, inject } from "@vue/composition-api";

export default {
  name: "ASorItemFluctuations",
  components: { ASorItemFluctuation },
  props: {
    fluctuations: Array,
  },
  setup(props, { root, emit }) {
    const onFluctuationUpdate = function (idx, evt) {
      let dataPoints = _.concat(props.fluctuations || [], []);
      dataPoints.splice(idx, 1, {
        ...props.fluctuations[idx],
        ...evt,
      });

      emit("input", dataPoints);
    };

    const onFluctuationDelete = function (idx) {
      let dataPoints = _.concat(props.fluctuations || [], []);
      dataPoints.splice(idx, 1);
      emit("input", dataPoints);
    };

    return {
      onFluctuationUpdate,
      onFluctuationDelete,
    };
  },
};
</script>

<style lang="less">
.rbu-item-fluctuations {
  display: contents;
}
</style>
